import React, { useEffect, useState } from 'react';
import ToastService from '../../services/ToastService';

export default function ToastHost() {
  const [toasts, setToasts] = useState([]);
  useEffect(() => {
    const unsub = ToastService.subscribe((evt) => {
      if (evt.type === 'add') setToasts((t) => [...t, evt.toast]);
      if (evt.type === 'remove') setToasts((t) => t.filter(x => x.id !== evt.id));
    });
    return () => unsub();
  }, []);
  return (
    <div className="pl-toast-stack">
      {toasts.map(t => (
        <div
          aria-atomic="true"
          className="pl-toast"
          data-level={t.level}
          key={t.id}
          role={t.level === 'error' ? 'alert' : 'status'}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
